// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"86":"683bd828","848":"0449a07c","875":"7635ddaa","915":"0449a07c"}[chunkId] + ".chunk.css";
};